import { useQuery } from 'react-query';
import { TeamAPI } from 'api/admin/team';
import { TEAM_PARTICIPANTS } from 'helpers/constants';

export default function useTeamParticipants(id) {
  return useQuery(TEAM_PARTICIPANTS, () => TeamAPI.getAllParticipants(id));
}
